// import { Injectable } from '@angular/core';
// import { EventManager } from '@angular/platform-browser';
// import { Observable, Subject } from 'rxjs';

// type Options = {
//   element: any;
//   keys: string;
//   description?: string;
// };

// @Injectable({
//   providedIn: 'root'
// })
// export class HotkeyService {
//   defaults: Partial<Options> = {
//     element: window
//   };

//   // This keeps track of active shortcuts and also enables listing shortcuts later
//   private hotkeys = new Map<string, { description: string; callback: (event: KeyboardEvent) => void }>();

//   constructor(private eventManager: EventManager) {
//     console.log('🔥 HotkeyService INITIALIZED');

//     document.addEventListener('keydown', (e) => {
//       console.log('🧪 RAW KEYDOWN:', {
//         key: e.key,
//         alt: e.altKey,
//         ctrl: e.ctrlKey,
//         shift: e.shiftKey
//       });
//     });

//     this.initGlobalListeners();
//   }

//   private initGlobalListeners() {
//     this.addShortcut({ keys: 'alt.h', description: 'Go to Home/Dashboard' }).subscribe(() => {
//         // We will implement navigation logic later or let components subscribe
//         console.log('Alt+H pressed');
//     });
//   }

//   addShortcut(options: Partial<Options>): Observable<KeyboardEvent> {
//     const merged = { ...this.defaults, ...options };
//     const event = `keydown.${merged.keys}`;

//     return new Observable(observer => {
//       const handler = (e: KeyboardEvent) => {
//         e.preventDefault();
//         observer.next(e);
//       };

//       const dispose = this.eventManager.addEventListener(
//         merged.element,
//         event,
//         handler
//       );

//       // Store metadata for help dialog if needed later
//       if (merged.keys) {
//           this.hotkeys.set(merged.keys, { 
//               description: merged.description || '', 
//               callback: handler 
//           });
//       }

//       return () => {
//         dispose();
//         if (merged.keys) {
//             this.hotkeys.delete(merged.keys);
//         }
//       };
//     });
//   }

//   getHotkeys() {
//       return Array.from(this.hotkeys.entries()).map(([key, value]) => ({
//           key,
//           description: value.description
//       }));
//   }
// }


import { Injectable } from '@angular/core';

type Hotkey = {
  description?: string;
  callback: (event: KeyboardEvent) => void;
  allowInInput?: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class HotkeyService {
  private shortcuts = new Map<string, Hotkey>();
  private paused = false;

  constructor() {
    // console.log('🔥 HotkeyService INITIALIZED');

    document.addEventListener('keydown', (event) => {
      this.handleKeydown(event);
    });
  }

  addShortcut(
    combo: string,
    callback: (event: KeyboardEvent) => void,
    description?: string,
    allowInInput = false
  ) {
    this.shortcuts.set(combo.toLowerCase(), {
      callback,
      description,
      allowInInput,
    });
  }

  pause() {
    this.paused = true;
  }

  resume() {
    this.paused = false;
  }

  getHotkeys() {
    return Array.from(this.shortcuts.entries()).map(([key, value]) => ({
      key,
      description: value.description,
    }));
  }

  private handleKeydown(event: KeyboardEvent) {
    if (this.paused) return;

    const combo = this.normalize(event);
    if (!combo) return; // ⛔ modifier-only or invalid key

    const hotkey = this.shortcuts.get(combo);
    if (!hotkey) return; // ⛔ not a registered shortcut

    const isInput =
      event.target instanceof HTMLInputElement ||
      event.target instanceof HTMLTextAreaElement ||
      event.target instanceof HTMLSelectElement ||
      (event.target instanceof HTMLElement && event.target.isContentEditable);

    // ⛔ Block ONLY if shortcut is NOT allowed inside inputs
    if (isInput && !hotkey.allowInInput) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    hotkey.callback(event);
  }


  private normalize(event: KeyboardEvent): string | null {
    // Ignore modifier-only presses
    if (
      event.key === 'Control' ||
      event.key === 'Alt' ||
      event.key === 'Shift' ||
      event.key === 'Meta'
    ) {
      return null;
    }

    const keys: string[] = [];

    if (event.ctrlKey) keys.push('control');
    if (event.altKey) keys.push('alt');
    if (event.shiftKey) keys.push('shift');
    if (event.metaKey) keys.push('meta');

    keys.push(event.key.toLowerCase());

    return keys.join('.');
  }
}
